export default __webpack_public_path__ + "static/media/rocket_anim_115.88bf002c.png";